// import packages
import axios from 'axios';

// import lib
import config from './index';
import {
    getAuthToken,
    removeAuthToken,
    setAuthToken,
} from '../lib/localStorage';

axios.defaults.baseURL = config.API_URL;
axios.defaults.headers.common['Authorization'] = getAuthToken();

export const setAuthorization = token => {
    setAuthToken(token);
    axios.defaults.headers.common['Authorization'] = token;
};

export const removeAuthorization = () => {
    removeAuthToken();
    delete axios.defaults.headers.common['Authorization'];
    return window.location.href = '/login';
};

export const handleResp = respData => {
    try {
        if ([200, 400, 500].includes(respData.status)) return respData.data;
        if (respData && respData.status === 401) {
            return removeAuthorization();
        }
    } catch (err) {
        return removeAuthorization();
    }
};

export default axios;